import React from 'react'
import { getActivityIcon } from '../CommonFile/Function_utils';

function RecentActivityCard(props) {
    return (
        <div className="activity-timeline">
            {props.displayData.length > 0 ? (
                props.displayData.map((item, index) => {
                    const activity = getActivityIcon(item.activity_type);
                    return (
                        <div className="activity-item" key={index}>
                            {/* <div className="activity-icon blue"><Users size={14} /></div> */}
                            <div className={`activity-icon ${activity.className}`}>
                                {activity.icon}
                            </div>
                            <div className="activity-details">
                                <p className="activity-text"><strong>{item.activity_title} - {item.user_name}</strong><br />{item.activity_description}</p>
                                <span className="activity-time">{item.time_ago}</span>
                            </div>
                        </div>
                    )
                }))
                : (
                    (
                        <div className="empty-activity-state">
                            <div className="empty-icon">
                                <i className="bx bx-calendar-event"></i>
                            </div>

                            <h5>No Activity Found</h5>

                            <p>
                                There are no user login sessions available for today.
                            </p>
                        </div>
                    )
                )}
        </div>
    )
}

export default RecentActivityCard
